import http from '@/utils/http.js'

//获取banner列表
export function getHomeBannerList(id) {
  return http({
    url: '/api/web/contBanner/getBannerList/' + id,
    method: 'GET'
  })
}

// 获取首页数据看板配置
export function getDataBoard() {
  return http({
    url: '/api/web/dataBoard',
    method: 'GET'
  })
}

// 根据id查询文章信息
export function getArticleById(id) {
  return http({
    url: '/api/web/contArticle/getArticleDetail/' + id,
    method: 'GET'
  })
}

//查询上一篇文章和下一篇文章
export function getSideArticle(data) {
  return http({
    url: '/api/web/contArticle/getSideArticle',
    method: 'POST',
    data: data
  })
}

//分页查询文章信息列表
export function getArticlePage(data) {
  return http({
    url: '/api/web/contArticle/getArticlePage',
    method: 'GET',
    data: data
  })
}
// 通过code查询子模块以及关联的信息
export function getChildernList(code) {
  return http({
    url: '/api/web/configCategory/getChildernList/' + code,
    method: 'GET'
  })
}
//关键字搜索
export function searchArticle(data) {
  return http({
    url: '/api/web/contArticle/searchArticle',
    method: 'GET',
    data: data
  })
}

//查询发展历程列表
export function getTimelineList() {
  return http({
    url: '/api/web/timeline/list',
    method: 'GET'
  })
}

//查询公司联系信息列表
export function getCompanyContactList() {
  return http({
    url: '/api/web/companyContact/list',
    method: 'GET'
  })
}

//分页查询专家顾问表
export function getTeacherPage(data) {
  return http({
    url: '/api/web/teacher/page',
    method: 'GET',
    data: data
  })
}
